import { APP_CONSTANTS } from '@/app/config/constants';
import { titleCaseFromSlug } from '@/shared/utils/stringUtils';
import { PAGE_TITLES } from '../constants';

/**
 * Longest-prefix match against PAGE_TITLES, falling back to a title-cased
 * final path segment ("/organization-setup" -> "Organization Setup").
 */
export function getPageTitle(pathname: string): string {
  const exact = PAGE_TITLES[pathname];
  if (exact) return exact;

  const match = Object.keys(PAGE_TITLES)
    .filter((path) => pathname === path || pathname.startsWith(`${path}/`))
    .sort((a, b) => b.length - a.length)[0];
  if (match) return PAGE_TITLES[match] ?? APP_CONSTANTS.APP_NAME;

  const segment = pathname.split('/').filter(Boolean).at(-1);
  return segment ? titleCaseFromSlug(segment) : APP_CONSTANTS.APP_NAME;
}
